"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactJss = require("react-jss");
var _initVars = _interopRequireDefault(require("../../../utils/vars/initVars"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events */

/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var OFFSET = 10;
var vars = (0, _initVars.default)({
  applied: ["height", "insetInlineStart"]
});
var TableResizerLine = function TableResizerLine(_ref) {
  var containerWidth = _ref.containerWidth,
    handleResize = _ref.handleResize,
    height = _ref.height,
    id = _ref.id,
    position = _ref.position,
    resetSizes = _ref.resetSizes;
  var insetInlineStart = "calc(".concat(position / (containerWidth / 100), "% - ").concat(OFFSET, "px)");
  var classes = useStyles({
    height: height,
    insetInlineStart: insetInlineStart
  });
  return /*#__PURE__*/_react.default.createElement("caption", {
    key: "".concat(id, "-").concat(position),
    className: (0, _classnames.default)(classes.unset, classes.root, classes.variables),
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    onDoubleClick: resetSizes,
    onMouseDown: handleResize
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.resizer
  }));
};
TableResizerLine.displayName = "TableResizerLine";
var useStyles = (0, _reactJss.createUseStyles)(function (theme) {
  return {
    unset: {
      all: "unset"
    },
    variables: vars.styles,
    root: {
      position: "absolute",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "2px",
      width: 10 + OFFSET,
      top: -1,
      cursor: "col-resize",
      transition: "opacity 200ms linear",
      opacity: 0,
      "&:hover, &:active": {
        opacity: 1
      }
    },
    resizer: {
      width: 3,
      height: "100%",
      background: theme.colors.baseContrast040
    }
  };
}, {
  name: "TableResizer"
});
var _default = exports.default = TableResizerLine;